import { ConnectError } from "@connectrpc/connect";
import { t } from "./i18n";

export const ERROR_CODES = {
  // Connect 関連のエラー (C001-C999)
  CONNECT_APPLY_CAMPAIGN_FAILED: "C001",
  CONNECT_CREATE_MY_INVITER_FAILED: "C002",
  CONNECT_GET_MY_INVITATION_FAILED: "C003",
  CONNECT_GET_PRIMARY_CAMPAIGN_FUND_FAILED: "C004",
  CONNECT_GET_TENANT_FAILED: "C005",
  CONNECT_GET_MY_BALANCES_FAILED: "C006",
  CONNECT_GET_STORE_FAILED: "C007",
  CONNECT_GET_MY_TRANSACTION_FAILED: "C008",
  CONNECT_LOGIN_FAILED: "C009",
  CONNECT_PAY_FAILED: "C010",
  CONNECT_UPSERT_TRANSFER_CODE_FAILED: "C011",
  CONNECT_GET_MY_CAMPAIGN_STATUSES_FAILED: "C012",
  CONNECT_GET_DISTRIBUTION_CODE_DETAIL_FAILED: "C013",
  CONNECT_CONSUME_DISTRIBUTION_CODE_FAILED: "C014",
  CONNECT_GET_STANDALONE_DISTRIBUTION_CODE_DETAIL_FAILED: "C015",
  CONNECT_CONSUME_STANDALONE_DISTRIBUTION_CODE_FAILED: "C016",
  CONNECT_GET_HOKKAIDO_R8_HOUSEHOLDER_CODE_STATUS_FAILED: "C017",
  CONNECT_CREATE_HOKKAIDO_R8_HOUSEHOLDER_CODE_USE_AS_WALLET_BALANCE_FAILED:
    "C018",

  // アプリケーション全般のエラー (E001-E999)
  FAILED_TO_GET_SUBSCRIPTION_ID: "E001",
  FAILED_TO_WRITE_SUBSCRIPTION_ID: "E002",
  LOTTERY_RESULT_UNSPECIFIED: "E003",
  PROFILE_READ_FAILED: "E004",
  SDK_PERMISSION_NOT_ACCEPTED: "E005",
  SDK_PERMISSION_ERROR: "E006",
  TENANT_NOT_FOUND: "E007",
  BOUSAI_RESOURCE_READ_FAILED: "E008",
  SDK_INTERNAL_2_ERROR: "E009",
  TRANSACTION_TYPE_UNSPECIFIED: "E010",
  SDK_METHOD_NOT_SUPPORTED: "E011",
  FAILED_TO_GET_REPRESENTED_SUBSCRIPTION_ID: "E012",
  RESIDENCE_CARD_REGISTRATION_FAILED: "E013",
  REQUEST_STORE_REVIEW_FAILED: "E014",
} as const;

export const ERROR_MESSAGES = {
  [ERROR_CODES.REQUEST_STORE_REVIEW_FAILED]: t("内部エラーが発生しました"),
  // Connect API関連のエラーメッセージ
  [ERROR_CODES.CONNECT_APPLY_CAMPAIGN_FAILED]: t(
    "キャンペーンへの応募に失敗しました",
  ),
  [ERROR_CODES.CONNECT_CREATE_MY_INVITER_FAILED]: t(
    "友だち招待の作成に失敗しました",
  ),
  [ERROR_CODES.CONNECT_GET_MY_INVITATION_FAILED]: t(
    "友だち招待の取得に失敗しました",
  ),
  [ERROR_CODES.CONNECT_GET_PRIMARY_CAMPAIGN_FUND_FAILED]: t(
    "キャンペーンデータの取得に失敗しました",
  ),
  [ERROR_CODES.CONNECT_GET_TENANT_FAILED]: t(
    "アプリ設定情報の取得に失敗しました",
  ),
  [ERROR_CODES.CONNECT_GET_MY_BALANCES_FAILED]: t("残高の取得に失敗しました"),
  [ERROR_CODES.CONNECT_GET_STORE_FAILED]: t("店舗情報の取得に失敗しました"),
  [ERROR_CODES.CONNECT_GET_MY_TRANSACTION_FAILED]: t(
    "取引履歴の取得に失敗しました",
  ),
  [ERROR_CODES.CONNECT_LOGIN_FAILED]: t("ログインに失敗しました"),
  [ERROR_CODES.CONNECT_PAY_FAILED]: t("決済に失敗しました"),
  [ERROR_CODES.CONNECT_UPSERT_TRANSFER_CODE_FAILED]: t(
    "受け取りコードの作成に失敗しました",
  ),
  [ERROR_CODES.CONNECT_GET_MY_CAMPAIGN_STATUSES_FAILED]: t(
    "キャンペーンステータスの取得に失敗しました",
  ),
  [ERROR_CODES.CONNECT_GET_DISTRIBUTION_CODE_DETAIL_FAILED]: t(
    "配布コードの詳細取得に失敗しました",
  ),
  [ERROR_CODES.CONNECT_CONSUME_DISTRIBUTION_CODE_FAILED]: t(
    "配布コードの受け取りに失敗しました",
  ),
  [ERROR_CODES.CONNECT_GET_STANDALONE_DISTRIBUTION_CODE_DETAIL_FAILED]: t(
    "受け取りコードの詳細取得に失敗しました",
  ),
  [ERROR_CODES.CONNECT_CONSUME_STANDALONE_DISTRIBUTION_CODE_FAILED]: t(
    "受け取りコードの受け取りに失敗しました",
  ),
  [ERROR_CODES.CONNECT_GET_HOKKAIDO_R8_HOUSEHOLDER_CODE_STATUS_FAILED]: t(
    "コードの確認に失敗しました",
  ),
  [ERROR_CODES.CONNECT_CREATE_HOKKAIDO_R8_HOUSEHOLDER_CODE_USE_AS_WALLET_BALANCE_FAILED]:
    t("ポイントの受け取りに失敗しました"),

  // アプリケーション全般のエラーメッセージ
  [ERROR_CODES.FAILED_TO_GET_SUBSCRIPTION_ID]: t(
    "アカウント情報の取得に失敗しました",
  ),
  [ERROR_CODES.FAILED_TO_WRITE_SUBSCRIPTION_ID]: t(
    "アカウント情報の登録に失敗しました",
  ),
  [ERROR_CODES.LOTTERY_RESULT_UNSPECIFIED]: t("抽選結果が未定義です"),
  [ERROR_CODES.PROFILE_READ_FAILED]: t(
    "プロフィール情報の読み取りに失敗しました",
  ),
  [ERROR_CODES.SDK_PERMISSION_NOT_ACCEPTED]: t(
    "ミニアプリに必要な権限が許可されていません",
  ),
  [ERROR_CODES.SDK_PERMISSION_ERROR]: t(
    "ミニアプリに必要な権限の取得に失敗しました",
  ),
  [ERROR_CODES.TENANT_NOT_FOUND]: t("テナントが見つかりませんでした"),
  [ERROR_CODES.BOUSAI_RESOURCE_READ_FAILED]: t(
    "防災アプリの登録が確認できませんでした",
  ),
  [ERROR_CODES.SDK_INTERNAL_2_ERROR]: t("内部エラーが発生しました"),
  [ERROR_CODES.TRANSACTION_TYPE_UNSPECIFIED]: t("取引タイプが未定義です"),
  [ERROR_CODES.SDK_METHOD_NOT_SUPPORTED]: t(
    "アプリの更新が必要です。更新を適用するため、アプリの再読み込みまたはストアへの移動を行います。",
  ),
  [ERROR_CODES.FAILED_TO_GET_REPRESENTED_SUBSCRIPTION_ID]: t(
    "代理登録に必要なアカウント情報の取得に失敗しました",
  ),
  [ERROR_CODES.RESIDENCE_CARD_REGISTRATION_FAILED]: t(
    "特定在留カード等の読み取りに失敗しました",
  ),
} as const;

type AppErrorOptions = {
  skipSentry?: boolean;
  sdkErrorNo?: number;
  originalError?: unknown;
};

export class AppError extends Error {
  public skipSentry: boolean;
  public sdkErrorNo?: number;

  constructor(
    public code: (typeof ERROR_CODES)[keyof typeof ERROR_CODES],
    message?: string,
    options?: AppErrorOptions,
  ) {
    const errorCode = options?.sdkErrorNo
      ? `${code}-S${options.sdkErrorNo}`
      : code;

    super(
      message
        ? `${errorCode}: ${message}`
        : `${errorCode}: ${ERROR_MESSAGES[code]}`,
    );

    this.name = "AppError";
    this.skipSentry = options?.skipSentry ?? false;
    this.sdkErrorNo = options?.sdkErrorNo;

    const originalError = options?.originalError;

    // Connectの403はSentryに送信しない
    if (originalError instanceof ConnectError) {
      if (originalError.rawMessage === "permission_denied") {
        this.skipSentry = true;
      }
    }
  }
}

if (import.meta.vitest) {
  const { describe, it, expect } = import.meta.vitest;

  describe("AppError", () => {
    it("デフォルトメッセージでエラーを作成できる", () => {
      const error = new AppError(ERROR_CODES.CONNECT_LOGIN_FAILED);
      expect(error.message).toBe("C009: ログインに失敗しました");
      expect(error.code).toBe("C009");
      expect(error.name).toBe("AppError");
      expect(error.skipSentry).toBe(false);
      expect(error.sdkErrorNo).toBeUndefined();
    });

    it("カスタムメッセージでエラーを作成できる", () => {
      const error = new AppError(
        ERROR_CODES.CONNECT_LOGIN_FAILED,
        "カスタムエラーメッセージ",
      );
      expect(error.message).toBe("C009: カスタムエラーメッセージ");
    });

    it("SDKエラー番号付きでエラーを作成できる", () => {
      const error = new AppError(ERROR_CODES.CONNECT_LOGIN_FAILED, undefined, {
        sdkErrorNo: 123,
      });
      expect(error.message).toBe("C009-S123: ログインに失敗しました");
      expect(error.sdkErrorNo).toBe(123);
    });

    it("Sentryスキップオプション付きでエラーを作成できる", () => {
      const error = new AppError(ERROR_CODES.CONNECT_LOGIN_FAILED, undefined, {
        skipSentry: true,
      });
      expect(error.skipSentry).toBe(true);
    });
  });
}
